var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.61342 15.0536C9.13342 14.5336 9.13342 13.6936 8.61342 13.1736L3.44008 8.0003L8.61342 2.82696C9.13342 2.30696 9.13342 1.46696 8.61342 0.946962C8.09342 0.426963 7.25342 0.426963 6.73342 0.946963L0.613417 7.06696C0.0934174 7.58696 0.0934175 8.42696 0.613417 8.94696L6.73342 15.067C7.24008 15.5736 8.09342 15.5736 8.61342 15.0536Z"}));
}

ChevronLeft.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
